export default {"src":"/_next/static/media/disc-wheels.c788dd90.svg","height":382,"width":556,"blurWidth":0,"blurHeight":0};